module.exports = __webpack_public_path__ + "img/check_circle.53020ec6.svg";